import type { Supplier } from '../../../shared/api/suppliers.api'
import { supplierCompleteness } from '../supplierCompleteness'

// Индикатор «заполнено N из M» в карточке поставщика (этап 3, кусок C3):
// полоска + список пустых полей. Для РОЗ/ADMIN — кнопка «Заполнить»,
// открывает ту же модалку, что «Редактировать».
export function SupplierCompletenessPanel({
  supplier,
  onFill,
}: {
  supplier: Supplier
  onFill?: () => void
}) {
  const { filled, total, missing } = supplierCompleteness(supplier)
  const complete = missing.length === 0
  const percent = total > 0 ? Math.round((filled / total) * 100) : 100
  return (
    <div className="mt-4 rounded-xl border border-gray-200 bg-white p-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <span className="text-sm font-medium text-gray-900">
          Заполнено {filled} из {total}
        </span>
        {!complete && onFill && (
          <button onClick={onFill} className="text-sm text-brand-600 hover:text-brand-700">
            Заполнить
          </button>
        )}
      </div>
      <div
        className="mt-2 h-1.5 rounded-full bg-gray-100 overflow-hidden"
        role="progressbar"
        aria-valuenow={filled}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label="Заполненность карточки поставщика"
      >
        <div
          className={`h-full rounded-full ${complete ? 'bg-emerald-500' : 'bg-amber-500'}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <div className="mt-1.5 text-xs text-gray-500">
        {complete ? 'Карточка заполнена полностью' : `Не заполнено: ${missing.join(', ')}`}
      </div>
    </div>
  )
}
